import React from 'react'
import './Footer.scss'
const Footer: React.FC = () => {
    return(
        <div className='footer'>
            ©2023 Biblio. All rights reserved.
        </div>
    )
}

export default Footer